import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { BulkAddFailureViewModel } from '../device-list.component';

/** ダイアログタイプ */
export type DialogType = 'error' | 'warn' | 'info';

/** ダイアログオプション */
export type ErrorDialogOption = {
  /** タイプ */
  type: DialogType;

  /** メッセージ */
  message: string;

  /** タイトル */
  title?: string;

  /** 操作 */
  operation?: string;

  data: BulkAddFailureViewModel[];
};
@Component({
  selector: 'app-device-import-error-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    MatTableModule,
  ],
  templateUrl: './device-import-error-dialog.component.html',
  styleUrl: './device-import-error-dialog.component.scss',
})
export class DeviceImportErrorDialogComponent {
  /** タイトル */
  public title = 'Error';

  /** メッセージ */
  public message = '';

  /** 操作 */
  public operation: string | undefined;

  /** ダイアログタイプ */
  private type: DialogType = 'error';

  /** 登録失敗一覧情報 */
  public dataSource = new MatTableDataSource<BulkAddFailureViewModel>([]);

  /** カラム */
  public readonly displayedColumns: string[] = ['csvNo', 'serialNo', 'message'];

  /** デフォルトタイトル一覧 */
  private readonly defaultTitleList: Record<DialogType, string> = {
    info: 'Information',
    warn: 'Warning',
    error: 'Error',
  };

  /** タイトルCSSクラス一覧 */
  private readonly titleClassList: Record<DialogType, string> = {
    info: 'matp-bg-primary',
    warn: 'matp-bg-accent',
    error: 'matp-bg-warn',
  };

  /** タイトルアイコン一覧 */
  private readonly titleIconList: Record<DialogType, string> = {
    info: 'error',
    warn: 'check_circle',
    error: 'cancel',
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) data: ErrorDialogOption,
    private dialogRef: MatDialogRef<DeviceImportErrorDialogComponent>
  ) {
    this.type = data.type;
    this.title = data.title || this.defaultTitleList[data.type];
    this.message = data.message;
    this.operation = data.operation;
    this.dataSource.data = data.data;
  }

  /**
   * 操作を実行する
   */
  public doOperation() {
    this.dialogRef.close(true);
  }

  /** タイトルCSSクラス */
  public get titleClass(): string {
    return this.titleClassList[this.type];
  }

  /** タイトルアイコン */
  public get titleIcon(): string {
    return this.titleIconList[this.type];
  }
}
